import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Inject } from '@angular/core';

@Component({
  selector: 'giveaway-deliver-prize',
  templateUrl: './giveaway-deliver-prize.component.html',
  styleUrls: ['./giveaway-deliver-prize.component.scss'],
})
export class GiveawayDeliverPrizeComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public drawId: number,
    private _builder: FormBuilder
  ) {}
  @Output() onCodeSubmited: EventEmitter<Array<string>> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  deliverCodeForm = this._builder.group({
    code: [
      '',
      [Validators.required, Validators.maxLength(4), Validators.minLength(4)],
    ],
  });

  submitCode(): void {
    this.onCodeSubmited.emit([
      this.deliverCodeForm.get('code').value,
      this.drawId,
    ]);
  }

  closeDialog(): void {
    this.close.emit();
  }
}
